<template>
  <Form ref="formValidate" :label-width="labelPosition === 'top'? NaN: labelWidth" :label-position="labelPosition" :model="formData">
    <template v-for="(item, index) in formItems">
      <FormItem
        :key="`validate-form-${item.key}-${index}`"
        :label="`${item.label}`"
        :rules="item.rules"
        :prop="item.key"
        :style="{width: item.width || '100%', display: 'inline-block'}"
        v-if="!item.hide"
      >
        <MyFormItem
          :item="item"
          :formItems="formItems"
        />
      </FormItem>
    </template>
  </Form>
</template>
<script>
import MyFormItem from '@components/form-item'
import { formatDate  } from '@libs/util'
export default {
  name: 'validate-form',
  components: { MyFormItem },
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    labelWidth: {
      type: Number,
      default: 100
    },
    labelPosition: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    formData () {
      let formData = {}
      this.formItems.map(s => {
        if (s.type === 'appointmentDate') {
          formData[s.date.key] = formatDate(s.date.value)
          formData[s.select.key] = s.select.value
        } else {
          formData[s.key] = s.value
        }
      })
      return formData
    }
  },
  methods: {
    async validate () {
      const pass = await this.$refs['formValidate'].validate()
      if (pass) {
        return this.formData
      } else {
        return false
      }
    }
  }
}
</script>